/* eslint-disable no-debugger */
import { useEffect, useState } from 'react';

import useCustomerSatisfactionData from '../../../../state/landingPages/customerSatisfaction/UseCustomerSatisfactionData';
import useLandingPageData from '../../../../state/landingPages/UseLandingPageData';

const INITIAL_STATE = {
  certifications: [],
  isLoading: true
};

const useMyCustomerSatisfactions = () => {
  const { landingPageState } = useLandingPageData();
  const { personCustomerSatisfactionState, getPersonCustomerSatisfaction } = useCustomerSatisfactionData();
  const [state, setState] = useState(INITIAL_STATE);

  useEffect(() => {
    if (landingPageState.currentPerson?.personId) {
      getPersonCustomerSatisfaction(landingPageState.currentPerson?.personId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [landingPageState.currentPerson?.personId]);

  useEffect(() => {
    if (personCustomerSatisfactionState.isArrayLoading === false && personCustomerSatisfactionState.isArrayLoaded === true) {
      setState({
        customerSatisfactions: personCustomerSatisfactionState.arrayData || [],
        isLoading: false
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personCustomerSatisfactionState]);

  return {
    ...state
  };
};

export default useMyCustomerSatisfactions;